// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { hederaPreviewnet as _hederaPreviewnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the hederaPreviewnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 297
 * Chain Name: Hedera Previewnet
 * Default Block Explorer: https://hashscan.io/previewnet
 * Default RPC URL: https://previewnet.hashio.io/api
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { hederaPreviewnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: hederaPreviewnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const hederaPreviewnet = createCommon({
	..._hederaPreviewnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
